'use client';

import React, {FC} from 'react';
import cn from 'classnames';
import Image from 'next/image';
import {usePathname} from 'next/navigation';

import getAffiliatesImage from '../../utils/getAffiliatesImage';

import styles from './styles.module.scss';

const Logos: FC = () => {
  const pathname = usePathname();

  const affiliateImage: string = getAffiliatesImage(pathname);

  const affiliateContainerClassName = cn(styles.logos__affiliate, {
    [styles.logos__affiliate__modFortune]: pathname === '/forms/fortune',
    [styles.logos__affiliate__mod247Wallst]: pathname === '/forms/247wallst',
  });
  const affiliateLogoClassName = cn(styles.logos__affiliate_image, {
    [styles.logos__affiliate_image__modInvert]: pathname !== '/forms/joywallet',
  });

  return (
    <div className={styles.logos}>
      <Image
        src="/static/img/zoe-logo/Zoe_Logo_Blue.svg"
        alt="Zoe logo"
        width={62}
        height={25}
      />

      {affiliateImage && (
        <>
          <span className={styles.logos__divider} />

          <div className={affiliateContainerClassName}>
            <Image
              src={affiliateImage}
              fill
              sizes="100px"
              style={{objectFit: 'contain'}}
              className={affiliateLogoClassName}
              alt="affiliate"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Logos;
